/**
 * Page d'annulation après achat de crédits via Stripe
 */
import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { XCircle, ArrowLeft, ShoppingCart } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';

export default function CreditPurchaseCancel() {
  const [_searchParams] = useSearchParams();
  const navigate = useNavigate();

  const getDashboardUrl = () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const dashboardRoutes = {
      'super_admin': '/admin/super-dashboard',
      'admin': '/admin/dashboard',
      'cooper': '/cooper/dashboard',
      'member': '/member/dashboard',
      'expert': '/expert/dashboard'
    };
    return dashboardRoutes[user.role] || '/';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 flex items-center justify-center p-4">
      <Card className="max-w-md w-full shadow-xl border-0">
        <CardContent className="pt-8 text-center">
          <div className="w-24 h-24 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="h-12 w-12 text-slate-400" />
          </div>
          
          <h1 className="text-2xl font-bold text-slate-800 mb-2">
            Achat annulé
          </h1>
          
          <p className="text-slate-600 mb-6">
            Votre achat de crédits a été annulé. Aucun prélèvement n'a été effectué.
          </p>

          <div className="space-y-3">
            <Button 
              onClick={() => navigate(getDashboardUrl())}
              className="w-full h-12 bg-slate-800 hover:bg-slate-900"
            >
              <ArrowLeft className="mr-2 h-5 w-5" />
              Retour au tableau de bord
            </Button>
            
            <Button 
              onClick={() => window.history.back()}
              variant="outline"
              className="w-full h-12"
            >
              <ShoppingCart className="mr-2 h-5 w-5" />
              Réessayer l'achat
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
